import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type SupplyVariantFragment = { id: string, pk: number, name: string };

export const SupplyVariantFragmentDoc = gql`
    fragment SupplyVariantFragment on SupplyVariantType {
  id
  pk
  name
}
    `;